import { Pipe, PipeTransform } from '@angular/core';
import { ReserveInStoreService } from '@features/reserve-in-store/reserve-in-store.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Pipe({
    name: 'canChangeStoreInReservation',
    standalone: true
})
export class CanChangeStoreInReservationPipe implements PipeTransform {
    constructor(private readonly reservationInStoreService: ReserveInStoreService) {}

    transform(usedStoreId?: string | number, variantNo?: string): Observable<boolean> {
        return this.reservationInStoreService.reserveInStore$.pipe(
            map(({ storeId, items }) => {
                if (!items || !storeId || !items.length) {
                    return true;
                }

                // when we have multiples products we should not be able to change the favorite store
                if (items.length > 1) {
                    return false;
                }

                // we want to be sure we can allow change the favorite store in case we only have one product in the reservation
                if (items.length === 1 && !variantNo) {
                    return true;
                }

                return String(usedStoreId) === storeId;
            }),
            untilDestroyed(this)
        );
    }
}
